import React from "react";
import { imageCodes } from "../../template_codes/next/home_page_codes";

const Brand = () => {
  const images = [
    imageCodes.cat1.image,
    imageCodes.cat2.image,
    imageCodes.cat3.image,
    imageCodes.cat4.image,
    imageCodes.cat5.image,
    imageCodes.cat6.image,
    imageCodes.cat7.image,
    imageCodes.cat8.image,
    imageCodes.cat9.image,
    imageCodes.cat10.image,
    imageCodes.cat11.image,
    imageCodes.cat12.image,
    imageCodes.cat13.image,
    imageCodes.cat14.image,
  ];
  return (
    <div className="">
      <h1 className="text-4xl text-gray-700 font-bold text-center">
        Brand We Stocks
      </h1>
      <div className="flex flex-wrap gap-10 justify-center items-center my-5">
        {images?.map((item, i) => (
          <img
            key={i}
            src={item}
            alt=""
            className="rounded-xl shadow-xl w-24"
          />
        ))}
      </div>
    </div>
  );
};

export default Brand;
